import { render, staticRenderFns } from "./AscDescriptionsList.vue?vue&type=template&id=39f9f1f8&scoped=true&"
import script from "./AscDescriptionsList.vue?vue&type=script&lang=js&"
export * from "./AscDescriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./AscDescriptionsList.vue?vue&type=style&index=0&id=39f9f1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f9f1f8",
  null
  
)

export default component.exports